export default __webpack_public_path__ + "static/media/AeonikTRIAL-Regular.f252af92.otf";